import React, { useEffect, useState } from 'react';
import { WaitLoader } from '../../WaitLoader';

const PHASE_REASSURE_MS = 4000;
const PHASE_LONG_WAIT_MS = 12000;

type WaitPhase = 'initial' | 'reassure' | 'longWait';

export type CurriculumLoadingStateProps = {
  /** Primary line, e.g. "Loading National Curriculum" (trailing ellipsis/dots are added). */
  title?: string;
  className?: string;
};

function useWaitPhase(): WaitPhase {
  const [phase, setPhase] = useState<WaitPhase>('initial');

  useEffect(() => {
    const reassureTimer = window.setTimeout(() => setPhase('reassure'), PHASE_REASSURE_MS);
    const longWaitTimer = window.setTimeout(() => setPhase('longWait'), PHASE_LONG_WAIT_MS);
    return () => {
      window.clearTimeout(reassureTimer);
      window.clearTimeout(longWaitTimer);
    };
  }, []);

  return phase;
}

function secondaryMessage(phase: WaitPhase): string {
  if (phase === 'reassure') {
    return 'The first open in a session can take a little while.';
  }
  if (phase === 'longWait') {
    return 'Still working — first load can take up to about half a minute. The page is fine.';
  }
  return 'Please wait.';
}

/**
 * Inline wait UI for Plan curriculum trees. Phases reassure users during cold first loads (up to ~30s).
 */
export function CurriculumLoadingState({
  title = 'Loading curriculum',
  className = ''
}: CurriculumLoadingStateProps) {
  const phase = useWaitPhase();

  return (
    <WaitLoader
      className={className}
      title={title}
      secondary={secondaryMessage(phase)}
    />
  );
}
